export default __webpack_public_path__ + "static/sapphire-9da79d99b3de4dc4fcd246630a22d66f.jpg";